import { createSale } from '@lib/web3/contracts/Sale';
import createContractHook from '@lib/web3/hooks/contracts/createContractHook';

const useSale = createContractHook(createSale);
export default useSale;
